<campaign-editor-page
  previousPageTitle="{{ 'EMAIL_BUILDER.PAGE.PREVIOUS_PAGE_TOOLTIP' | translate }}"
  [previousPageURL]="backPageUrl$ | async"
  [context]="context$ | async"
  [locale]="locale$ | async"
>
  <ng-container #toolbar_actions>
    <campaign-editor-actions
      [context]="context$ | async"
      [campaignId]="campaignId$ | async"
      [campaignStepId]="campaignStepId$ | async"
      [ownerId]="ownerId$ | async"
    ></campaign-editor-actions>
  </ng-container>
</campaign-editor-page>
